import { APP_SERVER_CONTAINER_HOST } from '@/constants/AppConfig'

export const fetchConfig = async (
  url: string,
  verb?: string,
  revalidate?: number,
  body?: any,
  headers?: {
    'Content-Type': 'application/json'
  },
  tags?: string[] // Cache tags for grouped revalidation
) => {
  try {
    verb = verb || 'GET'
    revalidate = revalidate || 0

    // Add validation for required environment variables
    if (!APP_SERVER_CONTAINER_HOST) {
      console.error('APP_SERVER_CONTAINER_HOST is not defined')
      return null
    }

    // Configure caching based on revalidate parameter
    const fetchOptions: RequestInit = {
      method: verb,
      headers: headers,
      body: body ? JSON.stringify(body) : undefined,
    }

    // Add timeout for faster failure detection
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 10000) // 10 second timeout
    fetchOptions.signal = controller.signal

    // If revalidate is 0, disable caching (no-store)
    // If revalidate is greater than 0, enable caching with Next.js revalidation
    if (revalidate === 0) {
      fetchOptions.cache = 'no-store' // Disable caching to always fetch fresh data
    } else {
      fetchOptions.next = {
        revalidate: revalidate, // Cache for specified seconds
        tags: tags, // Cache tags for grouped revalidation
      }
    }

    const response = await fetch(`${APP_SERVER_CONTAINER_HOST}/api/v1${url}`, fetchOptions)
    clearTimeout(timeoutId) // Clear timeout on successful response

    if (!response.ok) {
      console.error('Failed to fetch:', response.status, response.statusText, url)
      // throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      return null
    }
    return await response.json()
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      console.error('Request timeout for:', url)
      return null
    }
    console.error('Error fetching config:', error)
    console.error('Error details:', {
      message: error instanceof Error ? error.message : 'Unknown error',
      stack: error instanceof Error ? error.stack : 'No stack trace',
      url: url,
      verb: verb,
    })
    return null
  }
}
